<aside
    class="sidebar"
    [ngClass]="{
        'mobile-open': isMobileMenuOpen()
    }"
>
    <!-- Logo Area -->
    <div class="sidebar-logo">
        <div class="logo-container">
            @if (logoPath) {
                <img [src]="logoPath" alt="logo" class="logo-icon" />
            }
            <span class="logo-text">{{ logoText }}</span>
        </div>
    </div>

    <!-- Navigation -->
    <nav class="sidebar-nav">
        <ul class="nav-list">
            @for (item of items; track item.label) {
                @if (!item.hide) {
                    @if (!item.children) {
                        <li class="nav-item">
                            <a
                                [routerLink]="item.route"
                                routerLinkActive="active"
                                [routerLinkActiveOptions]="{ exact: true }"
                                class="nav-link"
                                (click)="closeMobileMenu()"
                            >
                                <span class="nav-icon material-icons-outlined">{{ item.icon }}</span>
                                <span class="nav-label">{{ item.label }}</span>
                            </a>
                        </li>
                    } @else {
                        <li class="nav-item nav-group">
                            <button (click)="toggleSubmenu(item)" class="nav-link nav-accordion-trigger" [class.expanded]="item.expanded">
                                <span class="nav-icon material-icons-outlined">{{ item.icon }}</span>
                                <span class="nav-label">{{ item.label }}</span>
                                <span class="accordion-icon material-icons-outlined"> expand_more </span>
                            </button>

                            @if (item.expanded) {
                                <ul class="nav-submenu">
                                    @for (child of item.children; track child.label) {
                                        @if (!child.hide) {
                                            <li class="nav-item">
                                                <a
                                                    [routerLink]="child.route"
                                                    routerLinkActive="active"
                                                    [routerLinkActiveOptions]="{ exact: true }"
                                                    class="nav-link nav-sublink"
                                                    (click)="closeMobileMenu()"
                                                >
                                                    <span class="nav-label">{{ child.label }}</span>
                                                </a>
                                            </li>
                                        }
                                    }
                                </ul>
                            }
                        </li>
                    }
                }
            }
        </ul>
    </nav>

    <!-- Footer -->
    <!--    <div class="sidebar-footer">-->
    <!--        <a href="#" class="help-link">-->
    <!--            <span class="help-icon material-icons-outlined">help_outline</span>-->
    <!--            <span>Help & Support</span>-->
    <!--        </a>-->

    <!--        <div class="user-profile">-->
    <!--            <div class="user-avatar">AD</div>-->
    <!--            <div class="user-info">-->
    <!--                <div class="user-name">Admin User</div>-->
    <!--                <div class="user-role">Administrator</div>-->
    <!--            </div>-->
    <!--        </div>-->
    <!--    </div>-->
</aside>

<!-- Mobile Toggle Button (Visible only on mobile) -->
<button
    class="mobile-menu-toggle lg:hidden fixed top-4 left-4 z-50 bg-accent text-white rounded-lg p-2 shadow-lg"
    (click)="toggleMobileMenu()"
>
    <span class="material-icons-outlined">{{ isMobileMenuOpen() ? 'close' : 'menu' }}</span>
</button>

<!-- Mobile Overlay -->
@if (isMobileMenuOpen()) {
    <div class="mobile-overlay lg:hidden fixed inset-0 bg-black/50 z-40" (click)="closeMobileMenu()"></div>
}
